/* LIVACILS v2 : petits comportements de la couche design (aucune donnee modifiee). */
(function () {
  'use strict';

  /* 1. Fiche produit : "Acheter maintenant" est masque si Shopify affiche deja son bouton express. */
  var express = document.querySelector('.product-main__express');
  var buyNow = document.querySelector('.product-main__buy-now');
  if (express && buyNow) {
    var dedupe = function () {
      var hasExpress = express.querySelector('shopify-accelerated-checkout, .shopify-payment-button, [data-shopify="payment-button"]');
      if (hasExpress && express.offsetHeight > 20) buyNow.hidden = true;
    };
    dedupe();
    setTimeout(dedupe, 1500);
    setTimeout(dedupe, 4000);
  }

  /* 2. Studio : onglets Cils / Ongles (hub), choix de la prestation, barre de reservation fixe (mobile). */
  var bar = document.querySelector('[data-studio-sticky]');
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-svc]'));
  var current = null;

  function visibleCards() {
    return cards.filter(function (c) { return !c.closest('[data-svc-group][hidden]'); });
  }

  function paintBar() {
    if (!bar) return;
    var label = bar.querySelector('[data-book-bar-label]');
    var svcName = bar.querySelector('[data-book-bar-svc]');
    var btnGift = bar.querySelector('[data-book-bar-gift]');
    var meta = bar.querySelector('[data-book-bar-meta]');
    if (current) {
      var title = current.getAttribute('data-svc-title') || '';
      var price = current.getAttribute('data-svc-price') || '';
      if (label) label.textContent = 'Choisir mon créneau';
      var deposit = current.getAttribute('data-svc-deposit') || '';
      var priceNum = parseInt((price.match(/\d+/) || ['0'])[0], 10);
      var paidInFull = deposit && priceNum === parseInt(deposit, 10) && price.indexOf('dès') === -1;
      var suffix = !deposit ? '' : (paidInFull ? ' (réglée en ligne)' : ' (acompte ' + deposit + ' €)');
      if (svcName) svcName.textContent = '· ' + title + (price ? ', ' + price : '') + suffix;
      var metaText = meta && meta.querySelector('span');
      if (metaText) metaText.textContent = paidInFull ? 'Payée en ligne, rien à régler au studio' : 'Acompte à la réservation, le reste au studio';
      if (btnGift) btnGift.hidden = !current.querySelector('[data-svc-gift]');
      if (meta) meta.hidden = false;
    } else {
      if (label) label.textContent = 'Choisir ma prestation';
      if (svcName) svcName.textContent = '';
      if (btnGift) btnGift.hidden = true;
      if (meta) meta.hidden = true;
    }
  }

  function select(card) {
    cards.forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-selected', on);
      var pick = c.querySelector('[data-svc-pick]');
      if (pick) pick.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    current = card;
    paintBar();
  }

  cards.forEach(function (c) {
    var pick = c.querySelector('[data-svc-pick]');
    if (pick) pick.addEventListener('click', function () { select(c === current ? null : c); });
  });

  /* Onglets (presents seulement quand les deux univers sont sur la meme page) */
  var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-seg-target]'));
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-seg-target');
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      document.querySelectorAll('[data-svc-group]').forEach(function (g) {
        g.hidden = g.getAttribute('data-svc-group') !== target;
      });
      if (current && current.closest('[data-svc-group][hidden]')) select(null);
    });
  });

  if (bar && cards.length) {
    var btnBook = bar.querySelector('[data-book-bar-btn]');
    var btnGift = bar.querySelector('[data-book-bar-gift]');
    function trigger(attr) {
      var target = current && current.querySelector(attr);
      if (target) { target.click(); return true; }
      return false;
    }
    if (btnBook) btnBook.addEventListener('click', function () {
      if (!trigger('[data-svc-book]')) {
        var list = document.getElementById('prestations');
        if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    if (btnGift) btnGift.addEventListener('click', function () { trigger('[data-svc-gift]'); });
    paintBar();
    bar.hidden = false;
    bar.setAttribute('data-ready', '');
  }
})();
